import React, { useRef, useEffect } from "react";

const EmployeeDropdown = ({
  employeeName,
  handleEmployeeNameChange,
  showDropdown,
  currentItems,
  handleEmployeeSelect,
  currentPage,
  itemsPerPage,
  employeeList,
  paginate,
  goToFirstPage,
  goToLastPage,
  leftarrow,
  rightarrow,
  inputClassName,
  dropdownClassName,
  paginationClassName,
  dropdownClassName_2,
}) => {
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        showDropdown = false;
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <>
      <input
        type="text"
        value={employeeName}
        onChange={handleEmployeeNameChange}
        className={`${inputClassName}`}
        style={{ padding: "5px", outline: "none" }}
      />

      {showDropdown && currentItems.length > 0 && (
        <div
          ref={dropdownRef}
          className={`${dropdownClassName}`}
          style={{ position: "absolute" }}
        >
          {currentItems.map((employee, index) => (
            <div
              key={index}
              onClick={() => handleEmployeeSelect(employee)}
              className={`${dropdownClassName_2}`}
            >
              {employee.emp_first_name} {employee.emp_last_name} /{" "}
              {employee.staff_number}
            </div>
          ))}

          <div className={`${paginationClassName}`}>
            <a
              href="#"
              className="leftarrow-rounded"
              onClick={(e) => {
                e.preventDefault();
                goToFirstPage();
              }}
            >
              <img className="leftarrow-pagination" src={leftarrow} alt="" />
            </a>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                paginate(currentPage - 1);
              }}
            >
              {"<"}
            </a>
            {currentPage > 1 && (
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  paginate(currentPage - 1);
                }}
              >
                {currentPage - 1}
              </a>
            )}
            <a href="#" className="active">
              {currentPage}
            </a>
            {currentPage < Math.ceil(employeeList.length / itemsPerPage) && (
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  paginate(currentPage + 1);
                }}
              >
                {currentPage + 1}
              </a>
            )}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                paginate(currentPage + 1);
              }}
            >
              {">"}
            </a>
            <a
              href="#"
              className="rightarrow-rounded"
              onClick={(e) => {
                e.preventDefault();
                goToLastPage();
              }}
            >
              <img className="rightarrow-pagination" src={rightarrow} alt="" />
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default EmployeeDropdown;
